module.exports = __webpack_public_path__ + "img/SA3400D.293d0465.png";